import { render, staticRenderFns } from "./EntityCardV2026.vue?vue&type=template&id=edfa2cf4&scoped=true"
import script from "./EntityCardV2026.vue?vue&type=script&lang=js"
export * from "./EntityCardV2026.vue?vue&type=script&lang=js"
import style0 from "./EntityCardV2026.vue?vue&type=style&index=0&id=edfa2cf4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "edfa2cf4",
  null
  
)

export default component.exports